import Result from "@/core/common/Result";
import {
  IUsuariosPorEmpresaGateway,
  IUsuarioPorEmpresaResponse
} from "../ports/UsuarioPorEmpresaGateway";
import { inject, injectable } from "inversify";
import "reflect-metadata";
import { DITypes } from "@/core/@types/types";
import type { HttpClient } from "@/core/services/protocols/types";
import { IDefaultContabilResponse } from "@/services/contabil/types";

@injectable()
export class UsuarioPorEmpresaGatewayAdapter
  implements IUsuariosPorEmpresaGateway
{
  constructor(
    @inject(DITypes.CONTABIL_HTTP_CLIENT) private readonly http: HttpClient
  ) {}

  async getUsers(
    empresasId: string[] | undefined
  ): Promise<Result<IUsuarioPorEmpresaResponse[]>> {
    try {
      const response = await this.http.post<
        IDefaultContabilResponse<IUsuarioPorEmpresaResponse[]>
      >({
        url: "v1/contabil/portalcomunicacao/usuarios",
        body: {
          empresasId
        }
      });

      return Result.ok(response.body?.result || []);
    } catch (e) {
      return Result.fail("Não foi possível buscar os usuários");
    }
  }
}
